export const BUSINESS_TYPES = [
  "Distributors",
  "Inverter & Battery",
  "RO Water Purifier",
  "Aquarium Store",
  "Pet Grooming",
  "Veterinary Clinic",
  "Car Garage",
  "Bike Service",
  "Solar Panel Cleaning",
  "AC Service",
  "Pest Control",
  "CCTV Installation",
  "Generator Service",
  "Water Tank Cleaning",
  "Fire Extinguisher",
  "Gas Stove Service",
  "Home Appliance Repair",
  "Computer Repair",
  "Dental Clinic",
  "Eye Clinic",
  "Beauty Salon",
];

export const DEFAULT_INTERVALS = {
  "Distributors": 30,
  "Pet Grooming": 42,
  "Veterinary Clinic": 365,
  "Car Garage": 180,
  "Bike Service": 180,
  "Dental Clinic": 180,
  "Eye Clinic": 365,
  "Beauty Salon": 30,
  "RO Water Purifier": 180,
  "Pest Control": 90,
  "AC Service": 365,
  "Solar Panel Cleaning": 90,
  "Water Tank Cleaning": 180,
  "Fire Extinguisher": 365,
  "Inverter & Battery": 120,
  "Aquarium Store": 14,
  "CCTV Installation": 180,
  "Generator Service": 180,
  "Gas Stove Service": 365,
  "Home Appliance Repair": 365,
  "Computer Repair": 365,
};
